
import IrrigationView from './src/IrrigationView.vue' //智能灌溉
import IrrigationControl from './src/IrrigationControl.vue' //智能灌溉
import IrrigationControlConfig from './src/IrrigationControlConfig.vue' //设备控制策略
import IrrigationAnalysis from './src/IrrigationAnalysis.vue' //数据统计
import smartLocker from './src/smartLocker.vue' //数据统计

let views = {
    IrrigationView,
    IrrigationControl,
    IrrigationControlConfig,
    IrrigationAnalysis,
    smartLocker
};

export default views;